import { createFileRoute } from "@tanstack/react-router";
import { KeywordServiceLanding } from "@/components/KeywordServiceLanding";
import { keywordServiceHead } from "@/lib/keywordServicePages";
import { getTownMarketingPage } from "@/lib/townMarketingPages";

const PAGE = getTownMarketingPage("lone-tree");

export const Route = createFileRoute("/marketing-lone-tree")({
  head: () => keywordServiceHead(PAGE),
  component: () => <KeywordServiceLanding page={PAGE} />,
});
